"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Bind a change to given options, and scope it to act only inside a list
 */
// tslint:disable-next-line:no-any
exports.bindAndScopeChange = function (opts, condition, fn) {
    return function (editor) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!condition(opts, editor)) {
            return editor;
        }
        return fn.apply(void 0, [opts, editor].concat(args));
    };
};
//# sourceMappingURL=bindAndScopeChange.js.map